import getApiClient from '@/plugins/api'
import {translations as refundStatusTranslations, colors as refundStatusColors} from '@/helpers/orderRefundStatuses'

export default {
  formatAmount(amount) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(amount || 0)
  },

  refundStatusLabel(status) {
    return refundStatusTranslations[status] || status
  },

  refundStatusColor(status) {
    return refundStatusColors[status] || 'secondary'
  },

  round2(value) {
    return Math.round(value * 100) / 100
  },

  setFullRefund() {
    this.amount = this.refundableAmount
  },

  setNoRefund() {
    this.amount = 0
  },

  openConfirm() {
    if (!this.amountIsValid) {
      return
    }

    this.errorMessage = null
    this.confirmVisible = true
  },

  /**
   * Ask for the PIX the agency has to pay to fund the refund.
   *
   * A refund of zero has no PIX to pay, so the order is cancelled right away.
   */
  requestRefund() {
    const self = this,
      api = getApiClient(self.$store)

    self.confirmVisible = false
    self.errorMessage = null
    self.$store.commit('startLoading')

    api.patch(`orders/${self.order.id}/request_refund`, {
      amount: self.amount
    }, {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
      .then(result => {
        self.applyRefund(result.data)
      })
      .catch(error => {
        self.errorMessage = error.response?.data?.detail
          || error.response?.data?.['hydra:description']
          || 'Não foi possível solicitar o cancelamento. Tente novamente.'
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  applyRefund(refund) {
    this.refund = refund

    switch (refund.status) {
      case 'refunded':
        this.step = 'done'
        this.cancelCheckRefundStatus()
        this.$emit('refunded')
        break
      case 'pending_manual_refund':
      case 'paid':
        this.step = 'manual'
        this.cancelCheckRefundStatus()
        this.$emit('refunded')
        break
      case 'waiting_payment':
        this.step = 'pix'
        this.checkRefundStatus()
        break
      default:
        this.step = 'form'
        this.cancelCheckRefundStatus()
        this.errorMessage = 'Não foi possível gerar o PIX de reembolso. Tente novamente.'
    }
  },

  cancelCheckRefundStatus() {
    if (this.pixTimerId) {
      window.clearInterval(this.pixTimerId)
      this.pixTimerId = null
    }
  },

  checkRefundStatus() {
    const self = this,
      api = getApiClient(self.$store)

    self.cancelCheckRefundStatus()

    if (!self.refund || !self.refund.id) {
      return
    }

    self.pixTimerId = window.setInterval(() => {
      api.get(`order_refunds/${self.refund.id}/status`)
        .then(result => {
          if (result.data.status !== 'waiting_payment') {
            self.applyRefund(result.data)
          }
        })
        .catch(() => {
        })
    }, 5000)
  },

  addToClipboard(value) {
    navigator.clipboard.writeText(value)

    this.pixCodeCopied = true
    window.setTimeout(() => {
      this.pixCodeCopied = false
    }, 2000)
  },

  /**
   * Show the QR Code again when the page is reopened while the agency
   * still has a PIX to pay.
   */
  restoreActiveRefund() {
    const active = this.order.activeRefund

    if (!active) {
      return
    }

    this.amount = active.amount
    this.applyRefund({
      id: active.id,
      amount: active.amount,
      status: active.status,
      pix: {
        code: active.pixCode,
        qrCode: active.pixQrCode
      }
    })
  },

  startOver() {
    this.cancelCheckRefundStatus()
    this.refund = null
    this.amount = 0
    this.errorMessage = null
    this.step = 'form'
  }
}
